import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { editedFlag } from '../../balanceSheetManagement/rateChangeWorkpaperPage/highlightEdited';
import React from 'react';

function linkCellRenderer(CellRenderer) {
  function LinkCellWrapper(props) {
    return (
      <Link to={props.link} onClick={props.onClick}>
        <CellRenderer {...props}/>
      </Link>
    );
  }


  LinkCellWrapper.propTypes = {
    data: PropTypes.shape({
      [editedFlag]: PropTypes.bool,
    }).isRequired,
    link: PropTypes.string,
    onClick: PropTypes.func,
  };

  return LinkCellWrapper;
}

export default linkCellRenderer;
